__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "root";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@edgenuity/cwng-educator-api", "1.0.0", () => (Promise.all([__webpack_require__.e(672), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(2964))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(690), __webpack_require__.e(483), __webpack_require__.e(657)]).then(() => (() => (__webpack_require__(3657))))));
			register("@fortawesome/fontawesome-svg-core", "6.7.2", () => (__webpack_require__.e(564).then(() => (() => (__webpack_require__(3564))))));
			register("@fortawesome/react-fontawesome", "0.2.6", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(751), __webpack_require__.e(602)]).then(() => (() => (__webpack_require__(4221))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(483)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-router-dom", "6.28.2", () => (Promise.all([__webpack_require__.e(955), __webpack_require__.e(483), __webpack_require__.e(387)]).then(() => (() => (__webpack_require__(8955))))));
			register("react", "18.3.1", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};